import { Grid, Typography } from "@mui/material";

export const TrendCardMetric = ({ value, label }: { value: string, label: string }) => {

    return (
        <Grid
            item
            container
            lg={6}
            sm={12}
            display="flex"
            flexWrap="wrap"
            flexDirection="column"
            justifyContent="center"
            alignContent="center"
        >
            <Typography
                variant="caption"
                component="p"
                align="center"
                style={{ color: 'grey', padding: 0, margin: 0 }}
            >
                {label}
            </Typography>
            <Typography
                variant="body2"
                component="p"
                align="center"
                mb={1}
            >
                {value}
            </Typography>
        </Grid>
    );
}
